import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext();

export const useAuthContext = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [showLogin, setShowLogin] = useState(false);
  const [loginLoading, setLoginLoading] = useState(true);
  const [showSignup, setShowSignup] = useState(false);
  const [isLogin, setisLogin] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const [loginUsername, setloginUsername] = useState("Guest");

  const setUsername = (name) => {
    setloginUsername(name);
  };

  const handleLoginClick = () => {
    setShowLogin(true);
  };

  const setLoginTrue = () => {
    setisLogin(true);
  };
  const setLoginFalse = () => {
    setisLogin(false);
  };

  const handleCloseLogin = () => {
    setShowLogin(false);
  };

  const handleSignupClick = () => {
    setShowSignup(true);
  };

  const handleCloseSignup = () => {
    setShowSignup(false);
  };

  const contextValue = {
    isLogin,
    isAdmin,
    showLogin,
    showSignup,
    loginUsername,
    loginLoading,
    setLoginLoading,
    setUsername,
    setLoginTrue,
    setLoginFalse,
    setIsAdmin,

    handleLoginClick,
    handleCloseLogin,

    handleSignupClick,
    handleCloseSignup,
  };

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
}
